import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { CHESS_API, type Chess } from '@chess/api-chess';
import { REVIEW_API, positionAt, type Review } from '@chess/api-review';
import { useSelect } from '@chess/api-review/react';
import type { Color } from '@chess/api-model';
import { ORDER, balanceAt, materialOf } from './material.ts';
import { PlayerMaterial } from './PlayerMaterial.tsx';
import { useApi } from './useApi.ts';
import './material.css';

// The material on the players' lines beside the board, in review-board's
// `review.player.material` slot (one contribution per line, `{ color }`):
// what that player has lost from the full set, as glyphs grouped by kind,
// and on the line of the side that is ahead the lead in pawns. Follows the
// position on the board, explored lines and the look back included, as the
// strip under the step controls did until 2026-10-12. Reads the review and
// chess interfaces; owns nothing.

export function setup(app: PiletApi) {
  const Line: React.FC<{ params: { color: Color } }> = ({ params }) => {
    const review = useApi<Review>(app, REVIEW_API);
    const chess = useApi<Chess>(app, CHESS_API);
    const fen = useSelect(review, (s) => (s.status === 'ready' ? positionAt(s) : undefined));
    const sides = useSelect(review, (s) => s.game?.sides);
    const balance = React.useMemo(() => (chess ? balanceAt(chess, fen, sides) : undefined), [chess, fen, sides]);
    if (!balance) return null;
    return <PlayerMaterial {...materialOf(balance, params.color)} />;
  };
  app.registerExtension<{ color: Color }>('review.player.material', Line);
}

// Keep the piece order export reachable for consumers that lay out trays.
export { ORDER };
